import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DifficultyLevel, GameResult } from '../../../shared/enums';
import { IGameState } from '../types';
import { gameService } from '../services/GameService';
import { TGameType } from '../helpers';

export const gameModuleName = 'game';

const initialState: IGameState = {
  gamesList: [],
  started: false,
  result: null,
  type: null,
  difficulty: null,
  isSoundEnabled: true,
};

const gameSlice = createSlice({
  name: gameModuleName,
  initialState,
  reducers: {
    setGameType: (state, action: PayloadAction<TGameType>) => {
      state.type = action.payload;
    },
    invalidateGameType: (state) => {
      state.type = null;
    },
    setDifficulty: (state, action: PayloadAction<DifficultyLevel>) => {
      state.difficulty = action.payload;
    },
    invalidateDifficulty: (state) => {
      state.difficulty = null;
    },
    startGame: (state, action: PayloadAction<TGameType>) => {
      state.started = true;
      state.result = null;
      state.type = action.payload;
    },
    endGame: (state, action: PayloadAction<GameResult>) => {
      state.started = false;
      state.result = action.payload;
    },
    toggleSound: (state, action: PayloadAction<boolean>) => {
      state.isSoundEnabled = action.payload;
      window.isSoundEnabled = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(gameService.endpoints.getGamesList.matchFulfilled, (state, { payload }) => {
      state.gamesList = payload?.data || [];
    });
  },
});

export const {
  actions: { startGame, endGame, setGameType, invalidateGameType, setDifficulty, invalidateDifficulty, toggleSound },
} = gameSlice;

export const { reducer: gameReducer } = gameSlice;
